(function () {
  if (window.__v4uHoverVideo) return;
  window.__v4uHoverVideo = true;

  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!canHover || reduceMotion) return;

  function cardVideo(target, related) {
    var card = target.closest && target.closest('.card-wrapper');
    if (!card) return null;
    if (related && card.contains(related)) return null;
    return card.querySelector('video.v4u-hover-video');
  }

  document.addEventListener('mouseover', function (e) {
    var v = cardVideo(e.target, e.relatedTarget);
    if (!v) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  });

  document.addEventListener('mouseout', function (e) {
    var v = cardVideo(e.target, e.relatedTarget);
    if (!v) return;
    v.pause();
    try { v.currentTime = 0; } catch (err) {}
  });
})();
